import React from "react";
import ReactECharts from "echarts-for-react";

class BarChartTemplate3 extends React.Component {
  constructor(props) {
    super(props);
  }

  getOption = (barColor = "#5470C6", barSize = 40, graphData, xLabel, yLabel) => {
    return {
      tooltip: {
        trigger: "item",
      },
      grid: {
        left: 10,
        right: 30,
        top: 50,
      },
      legend: {
        show: true,
        top: 0,
        left: "center",
      },
      xAxis: {
        data: graphData ? graphData.map((el) => el && el.xProperties) : [],
        name: xLabel,
        nameLocation: "middle",
        nameGap: 54,
        nameTextStyle: {
          color: "#333",
          fontSize: 14,
          fontWeight: 500,
        },
      },
      yAxis: {
        name: yLabel,
        nameLocation: "middle",
        nameGap: 70,
        nameRotate: 90,
        nameTextStyle: {
          color: "#333",
          fontSize: 14.5,
          fontWeight: 500,
        },
      },
      series: [
        {
          name: xLabel,
          type: "bar",
          barWidth: barSize,
          data: graphData ? graphData.map((el) => el && el.yProperties) : [],
          itemStyle: {
            color: barColor,
          },
        },
      ],
    };
  };

  render() {
    const { graphData, xLabel, yLabel, graphHeight, barChartConfig } = this.props;
    const barSize = barChartConfig && parseInt(barChartConfig.barSize);
    const barColor = barChartConfig && barChartConfig.barColor;

    return (
      <div>
        <ReactECharts
          option={this.getOption(barColor, barSize, graphData, xLabel, yLabel)}
          style={{ height: graphHeight, width: "100%" }}
        />
      </div>
    );
  }
}

export default BarChartTemplate3;
